import React from 'react';
import { useHistory } from 'react-router-dom';

import useOnScreen from '../../helpers/useOnScreen';
import { TrackingContext } from '../../TrackingContext';
import { rsvpEventsRoute } from '../../helpers/routes';
import GuidanceCard from '../BaseGuidanceCard';

const RsvpGuidanceCard: React.FC = () => {
  const { track } = React.useContext(TrackingContext);
  const history = useHistory();
  const routeToWorkflow = () => {
    track('RSVP Settings Interaction', {
      action: 'start workflow',
      source: 'wws rsvp page',
    });
    history.push(rsvpEventsRoute);
  };

  const { ref } = useOnScreen({
    onFirstSeen: () => {
      track('WWS Dashboard Impression', {
        experimentName: 'RSVP Workflow',
        experimentVariant: 'Show Workflow',
        experimentState: 'Blank State',
      });
    },
  });

  return (
    <div ref={ref} data-testid="rsvp-guidance-card">
      <GuidanceCard
        type="rsvp"
        titleText="Online RSVP"
        primaryLinkText="Start Drafting your Form"
        primaryOnClick={routeToWorkflow}
        bulletPoints={[
          'Customize your online RSVP form',
          "Share your Website's link with your guests",
          "Instantly track guests' responses right here on The Knot!",
        ]}
      />
    </div>
  );
};

export default RsvpGuidanceCard;
